import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./pages/components/header/index.js";
import Footer from "./pages/components/footer/index.js";
import Home from "../src/pages/home/index.js"
import UnidadeSP from "./pages/home/unidadeSP/index.js";
import UnidadeRJ from "./pages/home/unidadeRJ/index.js";
import UnidadeSkyFit from "./pages/home/unidadeSkyFit/index.js"
import UnidadeLocatelli from "./pages/home/UnidadeLocatelli/index.js"

import ScrollToTop from "./pages/components/scrollTop/index.js";
import Galeria from "./pages/home/Galeria/index.js";

export default function AppRoutes(){
    return (
        <>
            <BrowserRouter basename="/">
            <Header/>
                <ScrollToTop/>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/galeria" element={ <Galeria/>}/>
                    <Route path="/unidadeSP" element={<UnidadeSP/>}/>
                    <Route path="/unidadeRJ" element={<UnidadeRJ/>}/>
                    <Route path="/unidadeSkyFit" element={<UnidadeSkyFit/>}/>
                    <Route path="/unidadeLocatelli" element={<UnidadeLocatelli/>}/>
                </Routes>
            <Footer/>
                
            </BrowserRouter>

        </>
    );
    
}